import routes from '@/routes/routes.json';

export const HeaderProductsJson: any = [
  {
    GoldLoan: [
      {
        ProductTitle: 'Gold loan from Home',
        ProductInfo: 'Find your nearest Muthoot FinCorp branch',
        ProductPathName: routes.goldLoan,
      },
      {
        ProductTitle: 'Gold loan From Branch',
        ProductInfo: 'Get money deposited in your bank account',
        ProductPathName: routes.goldLoan,
      },
    ],
  },
  {
    DigitalGold: [
      {
        ProductTitle: 'Buy Gold',
        ProductInfo: 'Find your nearest Muthoot FinCorp branch',
        ProductPathName: routes.buyGoldLanding,
      },
      {
        ProductTitle: 'Sell Gold',
        ProductInfo: 'Get money deposited in your bank account',
        ProductPathName: routes.sellGoldLanding,
      },
    ],
  },
  {
    Forex: [
      {
        ProductTitle: 'Buy Forex',
        ProductInfo: 'Get Multi-currency card or cash at your convenience',
        ProductPathName: routes.forexBuyOutsidePage,
        MoEngEventName: 'buy_forex',
      },
      {
        ProductTitle: 'Sell Forex',
        ProductInfo: 'Sell at competitive exchange rates with minimum efforts',
        ProductPathName: routes.forexSellOutsidePage,
        MoEngEventName: 'sell_forex',
      },
      {
        ProductTitle: 'Send Money Abroad',
        ProductInfo: 'Hassle-free international money transfers',
        ProductPathName: routes.forexSendMoneyAbroadOutsidePage,
        MoEngEventName: 'send_money_abroad',
      },

      {
        ProductTitle: 'Reload Forex Card',
        ProductInfo: 'Top-up your Forex Card anytime, anywhere',
        ProductPathName: routes.forexReloadCardOutsidePage,
        MoEngEventName: 'reload_forex_card',
      },

      {
        ProductTitle: 'Refer and Earn',
        ProductInfo: 'The more you share, the more you get',
        ProductPathName: '/forex/refer-and-earn',
        MoEngEventName: 'forex_refer_and_earn',
      },
    ],
  },

  {
    Payments: [
      {
        ProductTitle: 'Rent Payments',
        ProductInfo: 'Pay Rent Easily Via Credit Card',
        // ProductPathName: !!userId ? routes.billsLanding : routes.billsRent,
        ProductPathName: routes.billsRent,
      },
      {
        ProductTitle: 'Vendor Payments',
        ProductInfo: 'Make Payments Via Credit Card',
        // ProductPathName: !!userId ? routes.billsLanding : routes.billsVendors,
        ProductPathName: routes.billsVendors,
      },
    ],
  },
];

export const AvailableProducts = {
  GoldLoan: 'GoldLoan',
  DigitalGold: 'DigitalGold',
  Ncd: 'NCD',
  Forex: 'Forex',
  Payments: 'Payments',
  MSME: 'MSME',
  Blogs: 'Blogs',
  Careers: 'Careers',
};

export const HeaderProductsPostLoginJson: any = [
  {
    GoldLoan: [
      {
        ProductTitle: 'Gold loan from Home',
        ProductInfo: 'Find your nearest Muthoot FinCorp branch',
        ProductPathName: routes.goldLoan,
      },
      {
        ProductTitle: 'Gold loan From Branch',
        ProductInfo: 'Get money deposited in your bank account',
        ProductPathName: routes.goldLoan,
      },
    ],
  },
  {
    DigitalGold: [
      {
        ProductTitle: 'Buy Gold',
        ProductInfo: 'Find your nearest Muthoot FinCorp branch',
        ProductPathName: routes.buyGoldLanding,
      },
      {
        ProductTitle: 'Sell Gold',
        ProductInfo: 'Get money deposited in your bank account',
        ProductPathName: routes.sellGoldLanding,
      },
    ],
  },
  {
    Forex: [
      {
        ProductTitle: 'Buy Forex',
        ProductInfo: 'Get Multi-currency card or cash at your convenience',
        ProductPathName: routes.forexBuyOutsidePage,
        MoEngEventName: 'buy_forex',
      },
      {
        ProductTitle: 'Sell Forex',
        ProductInfo: 'Sell at competitive exchange rates with minimum efforts',
        ProductPathName: routes.forexSellOutsidePage,
        MoEngEventName: 'sell_forex',
      },
      {
        ProductTitle: 'Send Money Abroad',
        ProductInfo: 'Hassle-free international money transfers',
        ProductPathName: routes.forexSendMoneyAbroadOutsidePage,
        MoEngEventName: 'send_money_abroad',
      },
      {
        ProductTitle: 'Reload Forex Card',
        ProductInfo: 'Top-up your Forex Card anytime, anywhere',
        ProductPathName: routes.forexReloadCardOutsidePage,
        MoEngEventName: 'reload_forex_card',
      },

      {
        ProductTitle: 'Refer and Earn',
        ProductInfo: 'The more you share, the more you get',
        ProductPathName: '/forex/refer-and-earn',
        MoEngEventName: 'forex_refer_and_earn',
      },
    ],
  },

  {
    Payments: [
      {
        ProductTitle: 'Rent Payments',
        ProductInfo: 'Pay Rent Easily Via Credit Card',
        ProductPathName: routes.billsLanding,
      },
      {
        ProductTitle: 'Vendor Payments',
        ProductInfo: 'Make Payments Via Credit Card',
        ProductPathName: routes.billsLanding,
      },
    ],
  },
];
